import { TriangleAlert } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

/**
 * The arrears marker in a list row.
 *
 * It reads across every branch, not the one being browsed, which is why it is worth a column of
 * its own: the row that matters is the customer who is current here and behind somewhere else.
 * A clear row is a dash rather than a reassuring word, so the eye stops only on the exceptions.
 */
export function ArrearsIndicator({ inArrears }: { inArrears: boolean }) {
  if (!inArrears) {
    return (
      <span className="text-muted" aria-label="No arrears anywhere">
        —
      </span>
    )
  }

  return (
    <Badge tone="danger">
      <TriangleAlert className="size-3" aria-hidden />
      In arrears
    </Badge>
  )
}
